import React, { useState } from 'react';
import { toast } from 'sonner';
import { roundRobinAPI } from '../../lib/roundRobinApi';

const OPTS = [
  { value: 'none', label: 'No Championship', hint: 'Pool play only — no final match.' },
  { value: 'single', label: 'Single Championship', hint: 'One overall final: top two finishers across pools.' },
  { value: 'per_pool', label: 'Championship Per Pool', hint: 'Each pool/division gets its own final: #1 vs #2.' },
];

export const RRChampionshipFormat = ({ rr, onChanged }) => {
  const current = rr.championship_format || 'single';
  const [value, setValue] = useState(current);
  const [saving, setSaving] = useState(false);
  const locked = (rr.matches || []).some((m) => m.status === 'completed');

  const save = async () => {
    if (value === current) return;
    setSaving(true);
    try {
      await roundRobinAPI.update(rr.id, { championship_format: value });
      toast.success('Championship format updated.');
      onChanged?.();
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error((typeof d === 'string' ? d : d?.message) || 'Could not update championship format.');
      setValue(current);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="rounded-xl border border-[#e6e0d4] bg-white p-5" data-testid="rr-championship-format">
      <h3 className="text-lg font-semibold text-[#0c4f38]">Championship Format</h3>
      <p className="text-sm text-gray-500 mt-1">How the champion(s) are decided after pool play.</p>
      <div className="mt-4 space-y-2">
        {OPTS.map((o) => (
          <label
            key={o.value}
            className={`flex items-start gap-3 rounded-lg border p-3 cursor-pointer transition-colors ${value === o.value ? 'border-[#0c4f38] bg-[#f3f8f5]' : 'border-gray-200 hover:border-gray-300'} ${locked ? 'opacity-60 cursor-not-allowed' : ''}`}
            data-testid={`rr-champ-opt-${o.value}`}
          >
            <input
              type="radio" name="championship_format" value={o.value}
              checked={value === o.value} disabled={locked}
              onChange={() => setValue(o.value)} className="mt-1"
            />
            <span>
              <span className="block font-medium text-gray-900">{o.label}</span>
              <span className="block text-xs text-gray-500">{o.hint}</span>
            </span>
          </label>
        ))}
      </div>
      {locked ? (
        <p className="mt-3 text-sm text-amber-700" data-testid="rr-champ-locked-msg">
          Championship Format cannot be changed after play has started.
        </p>
      ) : (
        <button
          onClick={save} disabled={saving || value === current}
          data-testid="rr-champ-save-btn"
          className="mt-4 rounded-lg bg-[#0c4f38] px-4 py-2 text-sm font-medium text-white disabled:opacity-50"
        >
          {saving ? 'Saving…' : 'Save Championship Format'}
        </button>
      )}
    </div>
  );
};

export default RRChampionshipFormat;
